// extracted by mini-css-extract-plugin
module.exports = {"iconGroup":"IconGroup_iconGroup__19WG1","icon":"IconGroup_icon__297ON","notLastIcon":"IconGroup_notLastIcon__1FgqV","svg":"IconGroup_svg__19z9H"};